import { Box, Spacer } from '@chakra-ui/react';
import StrategyType from 'enums/modules/strategies/strategyType';
import { StrategyDetail } from 'model/modules/strategies/strategies';
import { FC } from 'react';
import OpenedPositionsTable from 'presentation/components/modules/portfolio/openedPositions/OpenedPositionsTable';
import StrategyIncomeCard from './income/StrategyIncomeCard';
import StrategyModelIncomeCard from './modelIncome/StrategyModelIncomeCard';
import PortfolioCompositionCard from './portfolioComposition/PortfolioCompositionCard';
import StrategyAboutCard from './StrategyAboutCard';
import StrategyAdvantagesCard from './StrategyAdvantagesCard';
import StrategyIndicatorsCard from './StrategyIndicatorsCard';
import StrategyIntroCard from './StrategyIntroCard';
import StrategyStatisticCard from './StrategyStatisticCard';
import AppCard from 'presentation/components/shared/card/AppCard';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import { useTranslation } from 'react-i18next';

interface Props {
  data: StrategyDetail;
  id: StrategyType;
}

const StrategyDetailLoaded: FC<Props> = ({ data, id }) => {
const { t } = useTranslation();

  return (
    <>
      <StrategyIntroCard
        title={data.intro.title}
        subtitle1={data.intro.subtitle1}
        subtitle2={data.intro.subtitle2}
        image={data.intro.image}
      />
      <Spacer h="20px" />
      <StrategyIncomeCard chart={data.incomeChart} currency={data.currency} />
      <Spacer h="10px" />
      <StrategyStatisticCard statistics={data.statistics} />
      <Spacer h="20px" />
      <StrategyIndicatorsCard data={data.indicators} />
      <Spacer h="20px" />
      <StrategyModelIncomeCard
        chartImage={data.modelIncome.chartImage}
        fromAmount={data.modelIncome.fromAmount}
        toAmount={data.modelIncome.toAmount}
        currency={data.currency}
        balanceChange={data.modelIncome.balanceChange}
        balanceChangePercent={data.modelIncome.balanceChangePercent}
        description={data.modelIncome.description}
        title={data.modelIncome.title}
      />
      <Spacer h="20px" />
      <PortfolioCompositionCard companies={data.portfolioComposition} />
      <Spacer h="20px" />
      <StrategyAdvantagesCard advantages={data.advantages} />
      <Spacer h="10px" />
      <StrategyAboutCard description={data.about} />
      {data.positions.length > 0 && (
        <Box mt="20px">
          <GridHeading>{t('stateOfPortfolio')}</GridHeading>
          <AppCard><OpenedPositionsTable items={data.positions} /></AppCard>
        </Box>
      )}
    </>
  );
};

export default StrategyDetailLoaded;
